import PropTypes from 'prop-types'
import React, { memo, useContext } from 'react'

import { Modal, Typography } from '../../../components/common/index'
import { LanguageContext } from '../../../context/LanguageContext'

const ConfirmationModal = ({
    showAlert,
    alertText,
    submitHandler,
    close,
    disableSubmitBtn,
    modalHeading,
    modalContent,
}) => {
    const { strings } = useContext(LanguageContext)

    const onConfirm = () => {
        submitHandler()
        close()
    }

    const heading = <Modal.Heading heading={modalHeading} cancelModalHandler={close} />

    const content = (
        <div className={'confirmation-content'}>
            {showAlert ? <Typography color={'danger'} display={'block'} text={alertText} /> : null}
            {!!modalContent && modalContent()}
        </div>
    )

    const actions = (
        <Modal.Actions
            cancelModalHandler={close}
            saveClickHandler={onConfirm}
            submitBtn={strings.CONFIRMATION_SUBMIT}
            cancelBtn={strings.CONFIRMATION_CANCEL}
            disabledBtn={disableSubmitBtn || false}
            color={'primary'}
            size={'xl'}
        />
    )

    return <Modal header={heading} content={content} actions={actions} size={'sm'} />
}

ConfirmationModal.propTypes = {
    /** @param submitHandler {Callback} -> Callback to perform submit action */
    submitHandler: PropTypes.func,

    /** @param close {Callback} -> Callback to perform close action */
    close: PropTypes.func,

    /** @param action {String} -> The action that needs to be confirmed, ex: Delete */
    action: PropTypes.string,

    /** @param records {String} -> if its singular/plural form of records displayed in heading message, ex: promo/promos */
    records: PropTypes.string,

    /** @param renderList {renderProps} -> callback which invokes list of selected records, to which the action is performed */
    renderList: PropTypes.func,

    /** @param disableSubmitBtn {Boolean} -> Flag to disable to submit button (optional) */
    disableSubmitBtn: PropTypes.bool,
}

export default memo(ConfirmationModal)
